import * as AxiosFunctions from '../functions/AxiosFunctions'
import { Liferay } from '../utils/liferay';


export type CardAlsea = { 
  tokenId: string;
  deviceSessionId: string;
};

export type CreateCardBody = {
  countryId?: number;
  name: string;
  secondName?: string;
  firstLastName?: string;
  secondLastName?: string;
  email: string;
  phone?: string;
  state?: string;
  city?: string;
  address?: string;
  zipCode?: string;
  card: CardAlsea;
  captchaToken: string;
};

export type CardResponse = {
  uuid?: string;
  version?: string;
  type?: string;
  date?: string;
  status?: string;
  exception?: string;
  message?: string;
  helpUrl?: string;
  content?: {
    cardId: number;
    isRecurrent: boolean;
  };
};

export type ChargeCardRequest = {
  deviceSessionId: string;
  amount: number;
  isRecurrent: boolean;
  periodicity: string
};

export type ChargeResponse = {
  uuid?: string;
  version?: string;
  type?: string;
  date?: string;
  status?: string;
  exception?: string;
  message?: string;
  helpUrl?: string;
  content?: {
    cardId: number;
    isRecurrent: boolean;
    chargeId?: number;
    transactionId?: string;
    billingId?: string | null;
    invoiceStatus?: "OK" | "FAILED";
    emailStatus?: "OK" | "FAILED";
  };
};

export type ChargeCardUpdate = { deviceSessionId: string };

export type ChargeAnonymous = { countryId: number };

export type CreateInvoice = { email: string; id: string };

export type CommonHeaders = {
  xUserAgent?: string;
  Authorization?: string;
  cognitoClient?: string;
};

const buildHeaders = (h: CommonHeaders = {}) => ({
  headers: {
    ...(h.xUserAgent ? { "X-User-Agent": h.xUserAgent } : {}),
    ...(h.Authorization ? { Authorization: h.Authorization } : {}),
    ...(h.cognitoClient ? { "cognito-client": h.cognitoClient } : {}),
    "Content-Type": "application/json",
    accept: "application/json",
  },
});



export async function getToken () {
  const csrfToken = Liferay.authToken;
  const response = await AxiosFunctions.postMethod(
      `/o/openpay-token-provider/getToken`,{},
      {
          headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
          }
      }
  );
  const data = response.data;
  return data;
}

export async function createCard(baseUrl:string, body: CreateCardBody, hdrs?: CommonHeaders) {
  const url = `${baseUrl}/cards`;
  const params=JSON.stringify(body)
  const res = await AxiosFunctions.postMethod(url, params, buildHeaders(hdrs));
  return res.data as CardResponse;
}

export async function createChargeByCardId(
  baseUrl:string,
  cardId: number,
  body: ChargeCardRequest,
  hdrs?: CommonHeaders
) {
  const url = `${baseUrl}/cards/${encodeURIComponent(cardId)}/charge`;
  const res = await AxiosFunctions.postMethod(url, body, buildHeaders(hdrs));
  return res.data as ChargeResponse;
}

export async function updateChargeByCardId(
  baseUrl:string,
  cardId: string,
  body: ChargeCardUpdate,
  hdrs?: CommonHeaders
) {
  const url = `${baseUrl}/cards/${encodeURIComponent(cardId)}/charge`;
  const res = await AxiosFunctions.putMethod(url, body, buildHeaders(hdrs));
  return res.data as CardResponse;
}

export async function createChargeAnonymous(
  baseUrl:string,
  body: ChargeAnonymous,
  hdrs?: Pick<CommonHeaders, "xUserAgent" | "cognitoClient">
) {
  const url = `${baseUrl}/charges`;
  const res = await AxiosFunctions.postMethod(url, body, buildHeaders(hdrs));
  return res.data as ChargeResponse;
}

export async function createInvoice(
  baseUrl:string,
  body: CreateInvoice,
  hdrs?: Pick<CommonHeaders, "xUserAgent" | "cognitoClient">
) {
  const url = `${baseUrl}/invoice`;
  const res = await AxiosFunctions.postMethod(url, body, buildHeaders(hdrs));
  return res.data as ChargeResponse;
}